<ng-container rtBlock="sc-privacy-page">
    <sc-page-header>
        <h1 slot="title" i18n="@@breadcrumbPrivacy">Политика конфиденциальности</h1>
    </sc-page-header>

    <div rtElem="body">
        <aside rtElem="toc" aria-label="Table of contents" i18n-aria-label="@@privacyTocLabel">
            <h2 rtElem="toc-title" i18n="@@privacyTocHead">Содержание</h2>
            <ol rtElem="toc-list">
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s1"
                        i18n="@@privacyToc1"
                        [rtMod]="{ active: activeSectionId() === 's1' }"
                        (click)="onTocClick($event, 's1')">
                        Общие положения
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s2"
                        i18n="@@privacyToc2"
                        [rtMod]="{ active: activeSectionId() === 's2' }"
                        (click)="onTocClick($event, 's2')">
                        Какие данные мы собираем
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s3"
                        i18n="@@privacyToc3"
                        [rtMod]="{ active: activeSectionId() === 's3' }"
                        (click)="onTocClick($event, 's3')">
                        Цели и правовые основания
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s4"
                        i18n="@@privacyToc4"
                        [rtMod]="{ active: activeSectionId() === 's4' }"
                        (click)="onTocClick($event, 's4')">
                        Cookies и аналитика
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s5"
                        i18n="@@privacyToc5"
                        [rtMod]="{ active: activeSectionId() === 's5' }"
                        (click)="onTocClick($event, 's5')">
                        Третьи лица и передача
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s6"
                        i18n="@@privacyToc6"
                        [rtMod]="{ active: activeSectionId() === 's6' }"
                        (click)="onTocClick($event, 's6')">
                        Сроки и хранение
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s7"
                        i18n="@@privacyToc7"
                        [rtMod]="{ active: activeSectionId() === 's7' }"
                        (click)="onTocClick($event, 's7')">
                        Права субъекта
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s8"
                        i18n="@@privacyToc8"
                        [rtMod]="{ active: activeSectionId() === 's8' }"
                        (click)="onTocClick($event, 's8')">
                        Контакты оператора
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s9"
                        i18n="@@privacyToc9"
                        [rtMod]="{ active: activeSectionId() === 's9' }"
                        (click)="onTocClick($event, 's9')">
                        Изменения политики
                    </a>
                </li>
            </ol>
        </aside>

        <main rtElem="main">
            <section rtElem="section" id="s1">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">01 /</span>
                    <span i18n="@@privacyS1Title">Общие положения</span>
                </h2>
                <p rtElem="section-p" i18n="@@privacyS1P1">
                    Настоящая Политика определяет порядок обработки и защиты персональных данных пользователей сервиса GoldenCalc (далее —
                    «Сервис»), доступного по адресам goldencalc.ru, goldencalc.by и goldencalc.com. Сервис предоставляется в режиме AS-IS и
                    представляет собой клиентский онлайн-конструктор для расчёта деревянных лестниц.
                </p>
                <p rtElem="section-p" i18n="@@privacyS1P2">
                    Все расчёты и визуализации выполняются в браузере пользователя; геометрические параметры лестницы, введённые в
                    конструктор, не передаются на серверы Оператора и не являются персональными данными в смысле 152-ФЗ.
                </p>
                <div rtElem="callout">
                    <div rtElem="callout-tag" i18n="@@privacyS1CalloutTag">Ключевой принцип</div>
                    <span i18n="@@privacyS1CalloutBody">
                        Оператор минимизирует сбор персональных данных и не использует их в целях, не связанных с функционированием Сервиса.
                    </span>
                </div>
            </section>

            <section rtElem="section" id="s2">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">02 /</span>
                    <span i18n="@@privacyS2Title">Какие данные мы собираем</span>
                </h2>
                <p rtElem="section-p" i18n="@@privacyS2P1">При использовании Сервиса могут обрабатываться следующие категории данных:</p>
                <h3 rtElem="section-h3" i18n="@@privacyS2H1">2.1. Технические</h3>
                <ul rtElem="section-list">
                    <li i18n="@@privacyS2L1">IP-адрес и производная геолокация на уровне региона</li>
                    <li i18n="@@privacyS2L2">User-Agent, разрешение экрана, язык браузера</li>
                    <li i18n="@@privacyS2L3">Страницы, которые посещал пользователь, и длительность сеанса</li>
                    <li i18n="@@privacyS2L4">Идентификаторы cookie, установленные Сервисом и партнёрами</li>
                </ul>
                <h3 rtElem="section-h3" i18n="@@privacyS2H2">2.2. Добровольно предоставленные</h3>
                <ul rtElem="section-list">
                    <li i18n="@@privacyS2L5">Email-адрес и имя — при отправке формы обратной связи</li>
                    <li i18n="@@privacyS2L6">Текст сообщения в форме обратной связи</li>
                </ul>
                <p rtElem="section-p" i18n="@@privacyS2P2">
                    Геометрические параметры лестницы, материалы и результаты расчёта остаются в браузере пользователя и Оператором не
                    обрабатываются.
                </p>
            </section>

            <section rtElem="section" id="s3">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">03 /</span>
                    <span i18n="@@privacyS3Title">Цели и правовые основания</span>
                </h2>
                <p rtElem="section-p" i18n="@@privacyS3P1">
                    Правовым основанием для обработки персональных данных является согласие пользователя, данное путём продолжения
                    использования Сервиса после ознакомления с настоящей Политикой (для юрисдикций РФ и РБ) или явное согласие через
                    cookie-баннер (для юрисдикций ЕС и США).
                </p>
                <p rtElem="section-p" i18n="@@privacyS3P2">Цели обработки:</p>
                <ul rtElem="section-list">
                    <li i18n="@@privacyS3L1">Обеспечение работоспособности Сервиса и технической поддержки</li>
                    <li i18n="@@privacyS3L2">Анализ использования и улучшение пользовательского опыта</li>
                    <li i18n="@@privacyS3L3">Коммуникация по обращениям, отправленным через форму обратной связи</li>
                </ul>
            </section>

            <section rtElem="section" id="s4">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">04 /</span>
                    <span i18n="@@privacyS4Title">Cookies и аналитика</span>
                </h2>
                <p rtElem="section-p" i18n="@@privacyS4P1">
                    Сервис использует технические, аналитические и cookie-файлы третьих лиц. Полный перечень:
                </p>
                <!-- The list is always a table: at every width it fits, and the kit cards would change the page look. -->
                <rt-table
                    #cookieTable="rtTable"
                    rtElem="cookie-tbl"
                    ariaLabel="Cookie-файлы сервиса"
                    i18n-ariaLabel="@@privacyS4TableAria"
                    [dataSource]="cookies"
                    [columns]="cookieColumns"
                    [cards]="false">
                    <ng-container cdkColumnDef="name">
                        <th *cdkHeaderCellDef cdk-header-cell i18n="@@privacyS4TableName">Имя</th>
                        <td *cdkCellDef="let cookie" cdk-cell>
                            <code>{{ cookie.name }}</code>
                        </td>
                    </ng-container>

                    <ng-container cdkColumnDef="purpose">
                        <th *cdkHeaderCellDef cdk-header-cell i18n="@@privacyS4TablePurpose">Назначение</th>
                        <td *cdkCellDef="let cookie" cdk-cell>{{ cookie.purpose }}</td>
                    </ng-container>

                    <ng-container cdkColumnDef="provider">
                        <th *cdkHeaderCellDef cdk-header-cell i18n="@@privacyS4TableProvider">Провайдер</th>
                        <td *cdkCellDef="let cookie" cdk-cell>{{ cookie.provider }}</td>
                    </ng-container>

                    <ng-container cdkColumnDef="duration">
                        <th *cdkHeaderCellDef cdk-header-cell i18n="@@privacyS4TableDuration">Срок</th>
                        <td *cdkCellDef="let cookie" cdk-cell>{{ cookie.duration }}</td>
                    </ng-container>

                    <tr *cdkHeaderRowDef="cookieTable.displayedColumns()" cdk-header-row></tr>
                    <tr *cdkRowDef="let cookie; columns: cookieTable.displayedColumns()" cdk-row></tr>
                </rt-table>
                <p rtElem="section-p" i18n="@@privacyS4P2">
                    Отключение cookie в настройках браузера не влияет на работоспособность конструктора, но может отключить сохранение
                    конфигураций между сеансами.
                </p>
            </section>

            <section rtElem="section" id="s5">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">05 /</span>
                    <span i18n="@@privacyS5Title">Третьи лица и передача</span>
                </h2>
                <p rtElem="section-p" i18n="@@privacyS5P1">
                    Оператор не передаёт персональные данные третьим лицам для целей, не связанных с функционированием Сервиса. Исключение —
                    аналитические провайдеры (Яндекс.Метрика, Google Analytics), обрабатывающие данные на основании собственных политик
                    конфиденциальности.
                </p>
                <div rtElem="callout">
                    <div rtElem="callout-tag" i18n="@@privacyS5CalloutTag">Для юрисдикции ЕС</div>
                    <span i18n="@@privacyS5CalloutBody">
                        Передача данных за пределы EEA осуществляется на основании Стандартных договорных условий (SCC) Европейской Комиссии
                        от 04.06.2021.
                    </span>
                </div>
            </section>

            <section rtElem="section" id="s6">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">06 /</span>
                    <span i18n="@@privacyS6Title">Сроки и хранение</span>
                </h2>
                <p rtElem="section-p" i18n="@@privacyS6P1">
                    Персональные данные обрабатываются в течение сроков, установленных применимым законодательством, и хранятся на серверах,
                    расположенных на территории Российской Федерации (для пользователей из РФ — в соответствии с требованиями 242-ФЗ), ЕС
                    (для пользователей из ЕС) или США (для пользователей из других юрисдикций).
                </p>
            </section>

            <section rtElem="section" id="s7">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">07 /</span>
                    <span i18n="@@privacyS7Title">Права субъекта персональных данных</span>
                </h2>
                <p rtElem="section-p" i18n="@@privacyS7P1">Субъект персональных данных имеет право:</p>
                <ul rtElem="section-list">
                    <li i18n="@@privacyS7L1">Получать информацию об обработке своих данных</li>
                    <li i18n="@@privacyS7L2">Требовать уточнения, блокирования или уничтожения</li>
                    <li i18n="@@privacyS7L3">Отзывать согласие на обработку в любой момент</li>
                    <li i18n="@@privacyS7L4">Обжаловать действия Оператора в Роскомнадзоре (РФ) или аналогичном органе</li>
                </ul>
            </section>

            <section rtElem="section" id="s8">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">08 /</span>
                    <span i18n="@@privacyS8Title">Контакты оператора</span>
                </h2>
                <p rtElem="section-p">
                    <span i18n="@@privacyS8P1A">Запросы субъектов персональных данных направляются по адресу:</span>
                    <b>staircraftdesigne&#64;gmail.com</b>
                    .
                    <span i18n="@@privacyS8P1B">Ответ предоставляется в течение 30 дней с момента получения запроса.</span>
                </p>
            </section>

            <section rtElem="section" id="s9">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">09 /</span>
                    <span i18n="@@privacyS9Title">Изменения политики</span>
                </h2>
                <p rtElem="section-p" i18n="@@privacyS9P1">
                    Оператор вправе вносить изменения в настоящую Политику. Новая редакция вступает в силу с момента её публикации на
                    Сервисе. Пользователи уведомляются о существенных изменениях через интерфейс Сервиса.
                </p>
            </section>
        </main>
    </div>
</ng-container>
